import { InjectionToken } from '@angular/core';
import { Feature, FeatureProperties } from '../../../../projects/client';

export const FEATURE_VALUE_STRATEGIES_TOKEN = new InjectionToken<FeatureValueStrategy[]>(
  'feature-value-strategies'
);

export interface FeatureValueStrategy {
  supports(feature: Feature<FeatureProperties, unknown>, propertyName: string): boolean;
  transformValue(
    feature: Feature<FeatureProperties, unknown>,
    propertyName: string,
    digitsInfo?: string
  ): string;
}
